import { render, staticRenderFns } from "./CatalogueNonWorking.vue?vue&type=template&id=4b50c50b&"
import script from "./CatalogueNonWorking.vue?vue&type=script&lang=js&"
export * from "./CatalogueNonWorking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports